import { render, staticRenderFns } from "./Comercial.vue?vue&type=template&id=21102922&scoped=true"
import script from "./Comercial.vue?vue&type=script&lang=js"
export * from "./Comercial.vue?vue&type=script&lang=js"
import style0 from "./Comercial.vue?vue&type=style&index=0&id=21102922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21102922",
  null
  
)

export default component.exports